import React from 'react'
import Image from '../../../images/sellerpolicies/14.png'

const Pr_gifting = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>PR Gifting</h2>
            <p>KAAY will be collaborating with a lot of bloggers/influencers on social media and will request sellers to send gifts for PR activity at least once a month or whenever required.</p>
        </div>
      </div>
    </div>
  )
}

export default Pr_gifting
